import React from "react";
import { Link } from "react-router-dom";

import "./footer.css";
import Logo from "../../assets/BlendzLogo.png";

function Footer() {
  return (
    <div className="FooterWrapper">
      <div className="FooterContainer">
        <div className="FooterRow">
          <div className="FooterLogo">
            <Link to="/">
              <img src={Logo} alt="Logo" height="50px" />
            </Link>
          </div>
          <div className="FooterLinksTitle">
            <h3>Links</h3>
          </div>
          <div className="FooterContactTitle">
            <h3>Contact Us</h3>
          </div>
        </div>
        <div className="FooterRow">
          <div className="FooterLinks">
            <Link to="/">Home</Link>
            <Link to="/beverages">Beverages</Link>
            <Link to="/dispensing">Dispensing Machinery</Link>
            <Link to="/resources">Resources</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/order">Order Here</Link>
          </div>
          <div className="FooterContact">
            <a href="tel:0800264948">0800 264 948</a>
            <a href="mailto:info@blendz.co.nz">info@blendz.co.nz</a>
            <p>282 Fordyce Road RD1,</p>
            <p>Helensville</p>
            <p>Auckland, 0874</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
